import React, { useState, useEffect } from "react";
import { ButtonGroup, Button } from "shards-react";

const OutControl = function (props) {
    let [outFlag, setOutFlag] = useState({});

    useEffect(() => {
        if (props.initialType !== null) {
            setOutFlag(props.initialType === true);
        }
    }, [props.initialType]);

    let switchDisplay = (event) => {
        const selectedId = event.currentTarget.id === "1";
        console.log("Switching OutFlag to: ", selectedId);
        if (event !== undefined)
            setOutFlag(selectedId);
        if (props.setOutFlag !== undefined)
            props.setOutFlag(selectedId);
    };

    return (
        <div>
            <ButtonGroup className="mb-3">
                <Button theme={outFlag === false || outFlag == null ? "primary" : "white"} id={"0"} onClick={(e) => { switchDisplay(e) }}>Will be there!</Button>
                <Button theme={outFlag === true ? "primary" : "white"} id={"1"} onClick={(e) => { switchDisplay(e) }}>Skipping this week!</Button>
            </ButtonGroup>
        </div>
    );
}

export default OutControl;